import { UeElement } from '@oneaudi/falcon-tools';
import React from 'react';
import styled from 'styled-components';
import type { ImageProps } from '../../EditorContentTypes';
import { SYS_BORDER_RADIUS_MD, SYS_BREAKPOINT_MD } from '@oneaudi/unified-web-common';

const StyledImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    border-radius: ${!process.env.IS_LEGACY ? SYS_BORDER_RADIUS_MD : '0px'};
  }
`;

// eslint-disable-next-line react/display-name
const Image: React.FC<ImageProps> = React.memo(
  ({ imageMobile, imageDesktop, alternativeText, propertyImageDesktop }: ImageProps) => (
    <picture>
      <UeElement type="media" property={propertyImageDesktop} label="Image">
        {(ueProps) => (
          <>
            <source media="(min-width:768px)" srcSet={imageDesktop.assetValue} {...ueProps} />
            <StyledImage src={imageMobile.assetValue} alt={alternativeText} {...ueProps} />
          </>
        )}
      </UeElement>
    </picture>
  ),
);

export default Image;
